import * as React from 'react';
import { ApplicationContext } from '../../../ApplicationContext';
import { useSelector } from 'react-redux';
import { selectOfferCategory, selectOfferId } from '../../../../selectors/offer';

import { trackShowRosbankPilotBanner, trackClickRosbankPilotBanner } from '../../tracking';
import { RosbankPilotBanner } from '../../components/RosbankPilotBanner';

/**
 * Контейнер, где формируется баннер для add-form.jade
 */
export const RosbankPilotBannerContainer: React.FC = () => {
  const { config } = React.useContext(ApplicationContext);
  const url = config.get<string>('rosbank-landing-frontend.landingUrl') as string;

  const category = useSelector(selectOfferCategory);
  const offerId = useSelector(selectOfferId);

  React.useEffect(() => {
    trackShowRosbankPilotBanner({ offerId, category });
  }, []);

  return <RosbankPilotBanner url={url} onClick={() => trackClickRosbankPilotBanner({ offerId, category })} />;
};
